import PageViewCounter from "./lib/PageViewCounter";
import EntryRoute from "./pages/EntryRoute";
import PublicProductRoute from './pages/PublicProductRoute';
import { useEffect } from "react";
import "@/App.css";
import './pages/praxis/essence/fonts.css';
import './pages/praxis/essence/footer.css';
import './components/review-intervals.css';
import './components/image-disclosure.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";


const EssenceDiscover=lazyNamed(()=>import('./pages/EssenceDiscover'));
const EssenceWelcome=lazyNamed(()=>import('./pages/EssenceWelcome'));
const EssenceDiscoverV2=lazyNamed(()=>import('./pages/EssenceDiscoverV2'));
const NotFound=lazyNamed(()=>import('./pages/NotFound'));
const EssenceInfo=lazyNamed(()=>import('./pages/EssenceInfo'));
const UpdatesConfirmation=lazyNamed(()=>import('./pages/AtlasPublic'),'UpdatesConfirmation');
const SharedCase=lazyNamed(()=>import('./pages/SharedCase'));

const Admin=lazyNamed(()=>import('./pages/Admin'));
const PraxisTool=lazyNamed(()=>import('./pages/PraxisTool'));
const IntakeForm=lazyNamed(()=>import('./pages/intake/IntakeForm'));
const IntakePrivacy=lazyNamed(()=>import('./pages/intake/IntakePrivacy'));
const IntakeThankYou=lazyNamed(()=>import('./pages/intake/IntakeThankYou'));
const KingdomCalcPublic=lazyNamed(()=>import('./pages/KingdomCalcPublic'));
import {LocaleBridge} from "./i18n/LocaleBridge";
import { AuthProvider, useAuth } from "./lib/auth";
import {DeferredArea,lazyNamed} from "./components/DeferredArea";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  const {user}=useAuth();
  return (
    <LocaleBridge language={user?.content_language}>
      <ScrollToTop />
      <PageViewCounter />
      <main>
        <DeferredArea><Routes>
          <Route path="/" element={<EntryRoute />} />
          <Route path="/neuigkeiten" element={<UpdatesConfirmation />} />
          <Route path="/case-share" element={<SharedCase/>} />
          <Route path="/welcome" element={<PublicProductRoute invitation><EssenceWelcome /></PublicProductRoute>} />
          <Route path="/discover" element={<PublicProductRoute invitation><EssenceDiscover /></PublicProductRoute>} />
          <Route path="/discover-v2" element={<PublicProductRoute invitation><EssenceDiscoverV2 /></PublicProductRoute>} />
          {["about","how-learning-works","sources-and-images","contact","impressum","datenschutz"].map(page=><Route key={page} path={`/${page}`} element={['how-learning-works','sources-and-images'].includes(page)?<PublicProductRoute><EssenceInfo page={page}/></PublicProductRoute>:<EssenceInfo page={page}/>}/>)}

          <Route path="/admin" element={<Admin />} />
          <Route path="/praxis-tool/*" element={<PraxisTool />} />
          {/* Phase 10 — public, patient-facing intake form. No
              auth wrapper. Slug-routed; the page itself handles
              not-available / preview / submission states. */}
          <Route path="/f/:slug" element={<IntakeForm />} />
          <Route path="/f/:slug/thanks" element={<IntakeThankYou />} />
          <Route path="/f/:slug/privacy" element={<IntakePrivacy />} />
          <Route path="/kingdom-test" element={<KingdomCalcPublic />} />
          <Route path="*" element={<NotFound />} />
        </Routes></DeferredArea>
      </main>
      <Toaster position="top-right" />
    </LocaleBridge>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
